import React from 'react';


class Datepicker extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this._initDatepicker();
	}

	componentDidUpdate() {
		this._initDatepicker();
	}

	componentWillUnmount() {
		this._destroyDatepicker();
	}

	_initDatepicker() {
		const element = this.refs[this.props.name];

		const direction = typeof this.props.direction !== 'undefined' ? this.props.direction : 0;
		const format = this.props.format ?? 'jS M Y';

		this.datepicker = window.jQuery(element).Zebra_DatePicker({
			icon: true,
		    format: format,
		    direction: direction,
		    onSelect: (arg) => {
		    	this._updateDate(arg);
		    }
		});
	}

	_destroyDatepicker() {
		const datepicker = this.datepicker.data('Zebra_DatePicker');

		datepicker.destroy();
	}

	_updateDate(newDateValue) {
		this.props.updateDateValue(this.props.name, newDateValue);
	}

	render() {
		return (
			<input type="text" ref={this.props.name} className="datepicker2" onChange={() => { return true; }} placeholder="Pick a date" autoComplete="off" value={this.props.value} />
		);
	}
}

export default Datepicker;